import React, { useCallback } from 'react';
import { Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getBillingInfoModalOpened } from 'logic/store/payment';
import { Text } from 'components/text/Text';
import { BillingInfoForm } from './billing-info.form';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Stack } from 'components/stack/stack';
import { colors } from 'styles/colors';
import styled from 'styled-components';
import { paymentSlice } from 'logic/store/payment/payment.slice';

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    .ant-modal-header {
      padding: 0;
    }

    .ant-modal-close {
      top: 10px;
    }

    .ant-modal-body {
      padding: 20px;
    }
  }
`;

export const BillingInfoModal = () => {
  const dispatch = useDispatch();
  const visible = useSelector(getBillingInfoModalOpened);
  const handleClose = useCallback(() => {
    dispatch(paymentSlice.actions.closeBillingInfoModal());
  }, [dispatch]);

  return (
    <ModalStyled
      visible={visible}
      onCancel={handleClose}
      footer={null}
      centered
      width={558}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 78,
          }}
        >
          <Text size={18} textAlign={'center'}>
            {translate(
              translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.header
            )}
          </Text>
        </div>
      }
      style={{
        maxWidth: 558,
      }}
    >
      <Stack flow={'row'} gap={1}>
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <InfoCircleOutlined style={{ marginRight: 12, color: colors.grayText, fontSize: 20 }} />
          <Text color={'grey'}>
            {translate(
              translationKeys.tutoringInstituteProfile.paymentsPage.billingInfoForm.warning
            )}
          </Text>
        </span>
        <BillingInfoForm />
      </Stack>
    </ModalStyled>
  );
};
